// Re-export shared impersonation utilities with debugging
import {
  getImpersonationCookie as _getImpersonationCookie,
  getImpersonationKitCookie as _getImpersonationKitCookie,
  deleteImpersonationCookie,
  deleteImpersonationKitCookie,
  IMPERSONATION_COOKIE_NAME,
  IMPERSONATION_KIT_COOKIE_NAME,
  setImpersonationCookie,
  setImpersonationKitCookie,
} from '@repo/utils';

// Wrapper with debugging
export function getImpersonationCookie(): string | undefined {
  const result = _getImpersonationCookie();
  return result;
}

// Wrapper with debugging for kit cookie
export function getImpersonationKitCookie(): string | undefined {
  const result = _getImpersonationKitCookie();
  return result;
}

export {
  deleteImpersonationCookie,
  deleteImpersonationKitCookie,
  IMPERSONATION_COOKIE_NAME,
  IMPERSONATION_KIT_COOKIE_NAME,
  setImpersonationCookie,
  setImpersonationKitCookie,
};
